import script from "./AddSerialNumberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSerialNumberDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddSerialNumberDialog.vue?vue&type=style&index=0&id=c115ba5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c115ba5c"]])

export default __exports__